import React from 'react';

interface Props {
  hasCurrentFeature: boolean;
  onClearOverlay?: () => void;
}

export const UndoRedoControl = ({ hasCurrentFeature, onClearOverlay }: Props) => {
  const handleClear = () => {
    if (onClearOverlay) {
      onClearOverlay();
    }
  };

  if (!hasCurrentFeature) return null;

  return (
    <div>
      <button
        type="button"
        className="p-1 text-17px font-semibold text-error"
        onClick={handleClear}
        disabled={!hasCurrentFeature}
        aria-label="Clear selection">
        Clear selection
      </button>
    </div>
  );
};
